import * as React from 'react';
import * as Common from '_common';
import { useHouseWidgets } from './components/house/HouseComponents';
export function useWidgetRegister() {
    const houseWidgets = useHouseWidgets();
    return React.useMemo(() => [...commonWidgets, ...houseWidgets], [houseWidgets]);
}
const commonWidgets = [
    {
        id: 'time',
        title: { en: 'Time', cs: 'Čas' },
        addDefaultFrame: true,
        components: {
            [Common.WidgetSize.MinButton]: {
                type: 'Widgets_TimeButton',
                properties: { minimized: true },
            },
            [Common.WidgetSize.Button]: { type: 'Widgets_TimeButton' },
            [Common.WidgetSize.Frame]: { type: 'Widgets_TimeFrame' },
            [Common.WidgetSize.FullScreen]: { type: 'Widgets_TimeFull' },
        },
    },
    {
        id: 'weather',
        title: { en: 'Weather', cs: 'Počasí' },
        components: {
            [Common.WidgetSize.Frame]: { type: 'Widgets_WeatherFull' },
        },
    },
];
